<ng-template #checkboxLegend let-anchor="anchor">
    <div class="d-flex align-items-center" style="white-space: nowrap">
        <span class="d-flex align-items-center">
            <fa-icon class="mr-1" [icon]="['fas', 'check-square']"></fa-icon>
            {{ '= Yes only,' | translate }}
        </span>
        <span class="d-flex align-items-center mx-2">
            <fa-icon class="mr-1" [icon]="['far', 'square']"></fa-icon>
            {{ '= No only,' | translate }}
        </span>
        <span class="d-flex align-items-center">
            <fa-icon class="mr-1" [icon]="['fas', 'minus-square']"></fa-icon>
            {{ '= All values (no filter)' | translate }}
        </span>
    </div>
</ng-template>

<span
    class="checkbox form-control-plaintext pr-2 position-relative d-inline align-middle"
    [class.disabled]="disabled"
    [ngClass]="[size, 'text-' + color]"
    (click)="onClick()">
    <span
        class="checkbox-icon-wrapper d-inline-block"
        kendoTooltip
        #checkboxTooltip="kendoTooltip"
        showOn="none"
        tooltipPosition="top"
        [tooltipTemplate]="checkboxLegend"
        (mouseenter)="nullableCheckbox && checkboxTooltip.show($event.target)"
        (mouseleave)="nullableCheckbox && checkboxTooltip.hide()">
        @if (nullableCheckbox) {
            @if (value === true) {
                <fa-icon [icon]="['fas', 'check-square']" [ngClass]="{ 'text-muted': disabled }"></fa-icon>
            }
            @if (value === false) {
                <fa-icon [icon]="['far', 'square']" [ngClass]="{ 'text-muted': disabled }"></fa-icon>
            }
            @if (isIndeterminate) {
                <fa-icon [icon]="['fas', 'minus-square']" [ngClass]="{ 'text-muted': disabled }"></fa-icon>
            }
        } @else {
            @if (value === true) {
                <fa-icon [icon]="['fas', 'check-square']" [ngClass]="{ 'text-muted': disabled }"></fa-icon>
            } @else {
                <fa-icon [icon]="['far', 'square']" [ngClass]="{ 'text-muted': disabled }"></fa-icon>
            }
        }
    </span>
</span>
<span
    class="checkbox-label align-middle"
    kendoTooltip
    [title]="tooltipTitle ? (tooltipTitle | translate) : (label | translate)">
    @if (icon) {
        <fa-icon [icon]="['fas', icon]"></fa-icon>
    }
    @if (!icon) {
        <span>{{ label | translate }}</span>
    }
</span>
